import React from "react"
import styles from "./styles.scss"

const FooterEnd = () => (
  <div className={styles.footerEnd}>
    <div className={styles.text}>
      <span className={styles.copyright}>
        © Sandström & Andreasson IT Solutions AB
      </span>
      <span className={styles.orgNumber}>559024-6491</span>
    </div>
  </div>
)

export default FooterEnd



// WEBPACK FOOTER //
// ./src/components/Footer/FooterEnd/index.jsx